import { Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2 } from "@angular/core"
import { debounceTime, Subject, Subscription } from "rxjs";

const DELAY = 1000

@Directive({
  selector: '[debounceClick]',
  standalone: true
})
export class DebounceClickDirective implements OnInit, OnDestroy
{
  @Input() debounceTime = DELAY
  @Input() shouldRemoveDisabledClass = true
  @Output() debounceClick = new EventEmitter()

  private clicks = new Subject()
  private subscription!: Subscription

  constructor(private renderer:Renderer2, private el:ElementRef){}

  ngOnInit(): void
  {
    try 
    {
      // A chaque clic, on a un delai de debouncTime avant que l'action associé au clic soit réalisé
      this.subscription = this.clicks.pipe(debounceTime(this.debounceTime)).subscribe((event:any) => {
        this.debounceClick.emit(event)

        if(this.shouldRemoveDisabledClass)
        {
          this.renderer.removeClass(this.el.nativeElement, "disabled")
        }
      })
    } 
    catch (error) 
    {
      this.handleError(error)
    }
  }

  ngOnDestroy(): void 
  {
    this.subscription?.unsubscribe()
  }

  @HostListener("click", ["$event"])
  clickEvent(event:Event)
  {
    try 
    {
      event.preventDefault()
      event.stopPropagation()

      this.renderer.addClass(this.el.nativeElement, "disabled")
      this.clicks.next(event)
    } 
    catch (error) 
    {
      this.handleError(error)
    }
  }

  handleError(error:unknown)
  {
    console.log(error)
    this.renderer.removeClass(this.el.nativeElement, "disabled")
  }
}
